import { render, staticRenderFns } from "./Drivers.vue?vue&type=template&id=ed56a800"
import script from "./Drivers.vue?vue&type=script&lang=js"
export * from "./Drivers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/8268df4d62037a26/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed56a800')) {
      api.createRecord('ed56a800', component.options)
    } else {
      api.reload('ed56a800', component.options)
    }
    module.hot.accept("./Drivers.vue?vue&type=template&id=ed56a800", function () {
      api.rerender('ed56a800', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/Collector/Drivers.vue"
export default component.exports